<template  lang="html">
    <Content v-if="$store.config.NAME=='Edesoft'  || $store.config.IS_LOCAL" class="content-sm" style="width: 100%; max-width: 300px; margin: 2em auto; padding: 1em; min-height: auto; flex-grow: 0; text-align: center">
        <img src="/immagini/logo.png" style="height: 80px; margin: 20px 0">
        <h2>Attivazione Demo</h2>
        <br>
    <Form v-if="sent==false && loading==false" :label-width="100" @submit.prevent.native="" :show-message="false">
      <FormItem  label ="Username" :rules="{required:true}"  prop="username">
        <Input v-model="username" name="username" :disabled="false"/>
      </FormItem>
      <FormItem label ="Email":rules="{required:true}"  prop="email">
        <Input v-model="email" name="email" :disabled="false"/>
      </FormItem>
      <!--
      <FormItem  label ="Partita Iva?":rules="{required:true}"  prop="iva">
      <RadioGroup v-model="iva" :value="iva_value">
        <Radio label ="true" :disabled="false">
          Sì
        </Radio>
        <Radio label ="false" :disabled="false">
          No
        </Radio>
      </RadioGroup>
      </FormItem>
      <FormItem  label ="Cassa":rules="{required:true}"  prop="cassa">
      <RadioGroup :value="cassa_value" v-model="cassa">
        <Radio label ="Classica" :disabled="false"/>
        <Radio label ="Con Competenza":disabled="false"/>
      </RadioGroup>
      </FormItem>
      -->
        <div style="text-align: center">
              
               <Button type="primary" @click="ApiSubmit()">
                 Invia
              </Button>
            </div>
      <input type="submit" style="display: none">
    </Form>
    <Spin size="large" fix v-if="loading"/>
    <div v-if="sent==true">
      <br>
      <h3>Registrazione demo quasi completata!</br></br>Controlla il tuo indirizzo email per completare l'attivazione, invece per tornare alla schermata di login clicca qui</h3>
      
    </div>
    <br>
    <a href="#/login">Torna alla schermata di login</a>
    </Content>
</template>
<script>


var user_form
export default 
{
      data () {
       return {
          user_form : null,
          username : '',
          email : '',
          iva_value : null,
          cassa_value : null,
          iva : null,
          cassa : null,
          sent : false,
          loading : false,
       }
       },
      mounted () {
       
      },
      methods: {
        ApiSubmit()
        {
            this.loading=true
            user_form = {
              username:this.username, 
              email:this.email, 
              name:this.username,
              is_admin:0,
              expiration_date:this.demoDate()
              //partita_iva:this.iva, 
              //cassa:this.cassa,
              };
            this.$http.post('users-noadmin', user_form).then(
                  res => {
                  user_form = null
                  this.sent = true }, 
                  err => {
                  console.log('error', err)
                  },).finally(res => {this.loading = false})
            this.$http.post('sendinblue/demo-form', user_form).then(res => {
              if(res.ok)
              {
                
                  
              }
              else
              {
                  user_form = null
                  this.loading=false
              }
            
        })
        },
        demoDate()
        {
            let current = new Date();
            let cDate = (current.getFullYear()) + '-' + (current.getMonth() + 1) + '-' + (current.getDate());
            var intDate = Date.parse(cDate)
            let demoDate = intDate + ( 24 * 60 * 60 * 1000 * 14)
            let new_current= new Date()
            new_current.setTime(demoDate)
            let dDate = (new_current.getFullYear()) + '-' + (new_current.getMonth() + 1) + '-' + (new_current.getDate());
            return dDate
        },
      },
}

</script>